import { forwardRef } from 'react';
import { BaseChip } from './ChipBase';
import { chipFilterDisabledStyle } from './chipDisabledStyle';
import { chipFilterStyle } from './chipFilterStyles';
import { XMarkIcon } from '../../Icons';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';

/** Compact elements that show attributes or action  */
import { jsx as _jsx } from "react/jsx-runtime";
export const FilterChip = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    label,
    classes,
    deleteIcon,
    className,
    disabled,
    onClick,
    sx,
    id,
    value,
    tabIndex
  } = props;
  const theme = useInterstateTheme();
  const filterStyle = mergeSxStyle({
    ...chipFilterStyle(theme),
    ...chipFilterDisabledStyle(theme)
  }, sx);
  const handleOnClick = valueString => {
    if (onClick) {
      onClick(valueString);
    }
  };
  return /*#__PURE__*/_jsx(BaseChip, {
    classes: classes,
    className: `FilterChip ${className || ''}`,
    disabled: disabled,
    label: label,
    onClick: () => handleOnClick(value || id),
    deleteIcon: deleteIcon || /*#__PURE__*/_jsx(Box, {
      display: 'flex',
      alignItems: 'center',
      children: /*#__PURE__*/_jsx(XMarkIcon, {
        "data-testid": 'XMarkIcon',
        fontSize: '12px'
      })
    }),
    onDelete: () => handleOnClick(value || id),
    ref: ref,
    sx: filterStyle,
    id: id,
    "data-testid": props['data-testid'],
    clickable: true,
    tabIndex: tabIndex
  });
});
FilterChip.displayName = 'FilterChip';